import request from "@/utils/request";

// 查询新手任务弹窗信息
export function getTaskTenant(params) {
  return request.post('/base/taskTenant/index', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

// 扭转租户任务状态
export function reverseTaskStatus(params) {
  return request.put('/base/taskTenant', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

// 查询租户任务完成状态信息
export function getTaskInfo(params) {
  return request.post('/base/taskTenant/task/info', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

// 根据组件地址获取视频地址
export function getTaskTenantVideoUrl(params) {
  return request.post('/base/taskTenant/video/url', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}